import React from 'react';
import { Layout } from '../../../components/Layout';
import { LeftSideMenu } from '../../../components/LeftSideMenu';

const LayoutWithLeftSideMenu = ({
  leftSideMenu = true,
  displayName,
  isLoggedIn,
  onLoginClick,
  onLogoutClick,
  isAuthorizing,
  pathname,
  ...props
}) => {
  return (
    <Layout
      displayName={displayName}
      isLoggedIn={isLoggedIn}
      onLoginClick={onLoginClick}
      onLogoutClick={onLogoutClick}
      isAuthorizing={isAuthorizing}
      leftSideMenu={leftSideMenu && <LeftSideMenu pathname={pathname} />}
    >
      {props.children}
    </Layout>
  );
};

export { LayoutWithLeftSideMenu };
